import React from 'react';
import { DatePicker,Radio, Tabs, Row, Col, Card, message, InputNumber, Icon, Checkbox, Skeleton, Button, Divider, Spin, Form } from 'antd';
import { observable, action, runInAction, toJS, computed } from 'mobx';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router'
import moment from 'moment';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import BetStatisticModal from './BetStatisticModal/BetStatisticModal';

import './MySummary.css';

import SummaryChartItemBlock from '@components/SummaryChartItemBlock/SummaryChartItemBlock';

import { getInitChartOption } from '@src/common/SummaryChart';

import my_summary_store from '@store/Pandect/MySummary/MySummaryStore1';
import bet_statistic_store from '@store/Pandect/MySummary/BetStatisticStore';
import login_user_store from '@store/LoginUser/LoginUserStore';
import update_agent_store from '@store/User/UserList/UpdateAgentStore';
import { form_item_size } from '@common/theme';
import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import GoToPage from '@common/GoToPage'

const { Meta } = Card;
const { TabPane } = Tabs;
const RangePicker = DatePicker.RangePicker;
const FormItem = Form.Item;
window.moment = moment;

@observer
class MetaTitle extends React.Component {
  render() {
    let is_fun = typeof this.props.value === 'function';
    return (
      <div style={{
        fontSize: '28px',
        textAlign: 'center',
      }}>
        {is_fun ? this.props.value() : this.props.value}
      </div>
    )
  }
}

class MetadDscription extends React.Component {
  render() {
    return (
      <div style={{
        fontSize: '16px',
        textAlign: 'center'
      }}>
        {this.props.description}
      </div>
    )
  }
}

@withRouter
@Form.create()
@observer
class MySummary extends React.Component {

  formItemLayout = {
    labelCol: {
      xs: { span: 6 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 12, offset: 0 },
      sm: { span: 12, offset: 0 },
    },
  };
  formItemLayouts = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
    },
    wrapperCol: {
      xs: { span: 22 },
      sm: { span: 22 },
    },
  };
  formItemStyle = {
    float: 'left',
    marginRight: '10px'
  }

  row_style = {
    marginBottom: '16px'
  }

  card_grid_style = {
    width: '25%',
    textAlign: 'center',
  }

  user_info_span_style = {
    marginRight: '15px'
  }

  /**
   * 标记是否正在拉取图标数据
   */
  @observable
  is_chart_data_fetching = false;

  @observable
  loading = true;

  @observable
  current_chart_title = '今日充值';

  @observable
  current_uid = '';

  @observable
  current_username = '';

  /**
   * 当前页面的用户 是否是 当前登录的用户
   */
  @computed
  get is_login_user() {
    let result = toJS(this.current_uid) == toJS(login_user_store.id);
    // console.log('is_login_user: ', result, toJS(this.current_uid), toJS(login_user_store.id));
    return result;
  }

  @observable
  submitting = false;

  @action
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (error, values) => {
      if (!error) {
        // console.log( values );
        let temp_value = {};
        temp_value.robot_stauts = values.robot_stauts ? 0 : 1;
        temp_value.is_withdrawal = values.is_withdrawal ? 0 : 1;
        temp_value.recommended_status = values.recommended_status ? 0 : 1;
        temp_value.is_change = values.is_change ? 0 : 1;
        temp_value.wallet_type = values.wallet_type ? 0 : 1;
        temp_value.determinedstars = values.determinedstars ? 0 : 1;
        temp_value.radio = values.radio.div(100);
        temp_value.id = this.current_uid;

        if (!login_user_store.isFirstLevel) {
          temp_value.type = 2;
        }

        // console.log( temp_value );

        runInAction(() => {
          this.submitting = true;
        })
        let result = await update_agent_store.updateToAgent(temp_value);
        runInAction(() => {
          this.submitting = false;
        })

        if (result.success) {
          message.success(`${this.current_username} 设置修改成功！`, 3);
          // 重置编辑表单
          // this.props.form.resetFields();
        } else {
          message.error(`${this.current_username} 设置修改失败！${result.error.error_data}`, 3);
        }

        return;
      }
    })
  }

  constructor(props) {
    super();

    this.current_uid = props.match.params.id;
    this.current_username = props.match.params.username;

    if (this.current_uid == login_user_store.id) {
      breadcrumb_store.resetByName('数据统计', '数据统计')
    }

    this.updateDatas();
  }

  componentWillReceiveProps(props) {
    this.current_uid = props.match.params.id;
    this.current_username = props.match.params.username;

    if (this.current_uid == login_user_store.id) {
      breadcrumb_store.resetByName('数据统计', '数据统计')
    }

    // this.updateDatas();
  }
  updateDatas() {

    my_summary_store
      .fetchHomePageData(this.current_uid)
      .then(() => {
        runInAction(() => {
          let y_data = []
          let x_data = []
          let y_data1 = []
          let x_data1 = []
          toJS(my_summary_store.Arr).map(item => {
            x_data.push(item.name)
            y_data.push(item.data)
          })
          this.chart_options.series[0].data = y_data;
          this.chart_options.xAxis[0].data = x_data;
          toJS(my_summary_store.Arr1).map(item => {
            x_data1.push(item.name)
            y_data1.push(item.data)
          })
          this.chart_options1.series[0].data = y_data1;
          this.chart_options1.xAxis[0].data = x_data1;
          this.loading = false;
        });
      });
  }

  @observable
  chart_options = getInitChartOption();

  @observable
  chart_options1 = getInitChartOption();

  @observable
  tabPosition = '6'

  @action
  handleSubmits = (e) => {
    e.preventDefault();
    this.tabPosition = e.target.value
        my_summary_store
        .fetchHomePageData(this.current_uid,Number(e.target.value))
        .then(() => {
          runInAction(() => {
            let y_data = []
            let x_data = []
            let y_data1 = []
            let x_data1 = []
            toJS(my_summary_store.Arr).map(item => {
              x_data.push(item.name)
              y_data.push(item.data)
            })
            this.chart_options.series[0].data = y_data;
            this.chart_options.xAxis[0].data = x_data;
            toJS(my_summary_store.Arr1).map(item => {
              x_data1.push(item.name)
              y_data1.push(item.data)
            })
            this.chart_options1.series[0].data = y_data1;
            this.chart_options1.xAxis[0].data = x_data1;
          });
        });
        return;
  }


  render() {
    let { getFieldDecorator } = this.props.form;
    return (
      <div style={{
        padding: '16px'
      }}>
        <BetStatisticModal />
        <Row style={{
          marginBottom: '16px'
        }}>
          <Col span={24}>
            <span style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#1890ff',
              marginRight: '10px'
            }}>
              {
                this.is_login_user ? '我' : `${this.current_username}`
              }
              的团队统计
            </span>
            {/* <span style={this.user_info_span_style}>
              返佣：{my_summary_store.rate}%
            </span>
            <Divider type='vertical' />
            <span style={this.user_info_span_style}>
              上级代理：{my_summary_store.myInfo.superiorPetName}
            </span>
            <Divider type='vertical' />
            <span style={this.user_info_span_style}>
              邀请码：{my_summary_store.myInfo.proxyNum}
            </span>
            <Divider type='vertical' />
            <span style={this.user_info_span_style}>
              上次登录时间：{my_summary_store.myInfo.lastLoginTime}
            </span>
            <Divider type='vertical' />
            <span style={this.user_info_span_style}>
              IP: {my_summary_store.myInfo.lastLoginIp}
            </span> */}
          </Col>
        </Row>
        <Radio.Group value={toJS(this.tabPosition)} buttonStyle="solid" onChange={this.handleSubmits}>
          <Radio.Button value="6">今日</Radio.Button>
          <Radio.Button value="5">昨日</Radio.Button>
          <Radio.Button value="4">本周</Radio.Button>
          <Radio.Button value="3">上周</Radio.Button>
          <Radio.Button value="2">本月</Radio.Button>
          <Radio.Button value="1">上月</Radio.Button>
        </Radio.Group>
        <Spin spinning={this.is_chart_data_fetching}>
          <Tabs defaultActiveKey="1" size='large' style={{ marginBottom: 32 }}>
            <TabPane tab="数据统计" key="1">
              <div style={{ width: '100%', display: 'flex' }} >
                <Card title="数据统计" bordered={false} style={{ width: '15%', fontSize: '16px', marginRight: '2%' }}>
                  <p>总提现:&nbsp;&nbsp;{
                    toJS(my_summary_store.sumBackMoney)[0] ? my_summary_store.sumBackMoney[0].data : null
                  }</p>
                  <p>总投注:&nbsp;&nbsp;{
                    toJS(my_summary_store.sumOrderMoney)[0] ? my_summary_store.sumOrderMoney[0].data : null
                  }</p>
                  <p>未开奖:&nbsp;&nbsp;
                  <span style = {{color: '#1890ff'}}>
                    {
                      toJS(my_summary_store.teamNotLottery)[0] ? my_summary_store.teamNotLottery[0].data : null
                    }
                  </span>
                  </p>
                  {/* <p>已开奖:&nbsp;&nbsp;
                    <span style = {{color: '#c43827'}}>
                    {
                      toJS(my_summary_store.teamHasLottery)[0] ? my_summary_store.teamHasLottery[0].data : null
                    }
                  </span>
                  </p> */}
                  {/* <p>已中奖:&nbsp;&nbsp;
                    {
                      toJS(my_summary_store.teamHasWinning)[0] ? my_summary_store.teamHasWinning[0].data : null
                    }
                  </p> */}
                  <p>返佣:&nbsp;&nbsp;
                  <span  style = {{color: '#c43827'}}>
                      {
                        Number(toJS(my_summary_store.teamCommissionData))
                      }
                  </span>
                  </p>
                  <p>线下充值:&nbsp;&nbsp;
                    {
                      toJS(my_summary_store.sumOffPayment)[0] ? my_summary_store.sumOffPayment[0].data : null
                    }
                  </p>
                  <p>线上充值:&nbsp;&nbsp;
                    {
                      toJS(my_summary_store.sumOnPayment)[0] ? my_summary_store.sumOnPayment[0].data : null
                    }
                  </p>
                  <p>会员赠送:&nbsp;&nbsp;
                    {
                      toJS(my_summary_store.teamPresentMembers)[0] ? my_summary_store.teamPresentMembers[0].data : null
                    }
                  </p>
                  <p>转充赠送:&nbsp;&nbsp;
                    {
                      toJS(my_summary_store.teamRechargingGift)[0] ? my_summary_store.teamRechargingGift[0].data : null
                    }
                  </p>
                  <p>代理赠送:&nbsp;&nbsp;
                    {
                      toJS(my_summary_store.teamAgentGift)[0] ? my_summary_store.teamAgentGift[0].data : null
                    }
                  </p>
                </Card>
                <Card style={{ width: '85%' }}>
                  <ReactEchartsCore
                    style={{
                      background: '#fff',
                      paddingBottom: '2px',
                      height: '520px',
                    }}
                    option={toJS(this.chart_options)}
                    echarts={echarts} />
                </Card>
              </div>
            </TabPane>
            <TabPane tab="人数统计" key="2">
              <div style={{ width: '100%', display: 'flex' }} >
                <Card title="人数统计" bordered={false} style={{ width: '15%', fontSize: '13px', marginRight: '1.2%' }}>
                  <p>新增会员:&nbsp;&nbsp;   {
                    toJS(my_summary_store.teamNewUser)[0] ? my_summary_store.teamNewUser[0].data : null
                  }</p>
                  <p>活跃会员:&nbsp;&nbsp;                        {
                    toJS(my_summary_store.teamActiveUsers)[0] ? my_summary_store.teamActiveUsers[0].data : null
                  }</p>
                  <p>提现人数:&nbsp;&nbsp;                        {
                    toJS(my_summary_store.teamNumWithdrawals)[0] ? my_summary_store.teamNumWithdrawals[0].data : null
                  }</p>
                  <p>充值人数:&nbsp;&nbsp;                        {
                    toJS(my_summary_store.teamNumRecharge)[0] ? my_summary_store.teamNumRecharge[0].data : null
                  }</p>
                  <p>下线代理:&nbsp;&nbsp;                        {
                   toJS(my_summary_store.teamNumOffAgents)[0] ? my_summary_store.teamNumOffAgents[0].data : null
                  }</p>
                  <p>下线会员:&nbsp;&nbsp;                        {
                    toJS(my_summary_store.teamNumOffMembers)[0] ? my_summary_store.teamNumOffMembers[0].data : null
                  }</p>
                </Card>
                <Card style={{ width: '85%' }}>
                  <ReactEchartsCore
                    style={{
                      background: '#fff',
                      paddingBottom: '2px',
                      fontSize:'12px',
                      height: '520px',
                    }}
                    option={toJS(this.chart_options1)}
                    echarts={echarts} />
                </Card>
              </div>
            </TabPane>
          </Tabs>
        </Spin>
        {/* <Row style={this.row_style}>
          <Col span={24}>
            <Card>
              <Card.Grid style={this.card_grid_style}>
                <Card
                  bordered={false}
                  // onClick={(e) => {
                  //   e.stopPropagation();
                  //   GoToPage.goProxyItemPath(this.current_uid, this.current_username);
                  // }}
                  >
                  <Meta
                    title={
                      <Skeleton
                        loading={this.loading}
                        active
                        paragraph={false}>
                        <MetaTitle value={my_summary_store.nextCountInfo.nextProxyNum}/>
                      </Skeleton>
                    }
                    description={
                      <MetadDscription description="下线代理"/>
                    }
                  />
                </Card>
              </Card.Grid>
              <Card.Grid style={this.card_grid_style}>
                <Card bordered={false}
                // onClick={() => {
                //   let uid = this.props.match.params.id;
                //   let userName = this.props.match.params.username;
                //   let type = 0;
                //   // 判断是否是 当前页面显示的数据是 当前登录用户 的还是 下级代理的数据
                //   if (uid === login_user_store.id) {
                //     type = 0;
                //   } else {
                //     type = 1;
                //   }

                //   GoToPage.goUserItemPath(type, uid, userName, {
                //     // search: userName
                //   })
                // }}
                >
                  <Meta
                    title={
                      <Skeleton
                        loading={this.loading}
                        active
                        paragraph={false}>
                        <MetaTitle value={my_summary_store.nextCountInfo.nextUserNum}/>
                      </Skeleton>
                    }
                    description={
                      <MetadDscription description="下线会员"/>
                    }
                  />
                </Card>
              </Card.Grid>
              <Card.Grid style={this.card_grid_style}>
                <Card
                  bordered={false}
                  // onClick={(e) => {
                  //   e.stopPropagation();
                  //   // GoToPage.goRechargePath({
                  //   //   agent: this.current_username, //代理的pet_name
                  //   //   // start_time: new Date().getStartTimestamp(), //开始时间
                  //   //   // end_time: new Date().getEndTimestamp(), //结束时间
                  //   // })
                  // }}
                  >
                  <Meta
                    title={
                      <Skeleton
                        loading={this.loading}
                        active
                        paragraph={false}>
                        <MetaTitle value={my_summary_store.nextCountInfo.nextBalance}/>
                      </Skeleton>
                    }
                    description={
                      <MetadDscription description="下线余额"/>
                    }
                  />
                </Card>
              </Card.Grid>
              <Card.Grid style={this.card_grid_style}>
                <Card bordered={false}>
                  <Meta
                    title={
                      <Skeleton
                        loading={this.loading}
                        active
                        paragraph={false}>
                        <MetaTitle value={my_summary_store.nextCountInfo.nextCaijin}/>
                      </Skeleton>
                    }
                    description={
                      <MetadDscription description="下线彩金"/>
                    }
                  />
                </Card>
              </Card.Grid>
            </Card>
          </Col>
        </Row> */}
        {/* {
          this.is_login_user ? null : (
            <Form>
              <FormItem
                label='返佣'
                colon={false}
                {...this.formItemLayout}
                style={this.formItemStyle}>
                {
                  getFieldDecorator('radio', {
                    initialValue: isNaN(my_summary_store.myInfo.radio) ? 0 : my_summary_store.myInfo.radio.mul(100),
                    rules: []
                  })(
                    <InputNumber
                      placeholder=''
                      size={form_item_size}
                      // style={input_style}
                      max={100}
                      min={0}
                      precision={1}
                      formatter={value => `${value}%`}
                      parser={value => value.replace('%', '')}
                      onChange={(value) => {
                        console.log("test", value)
                      }}
                      step={0.1} />
                  )
                }
              </FormItem>
              <FormItem
                style={this.formItemStyle}
                colon={false}>
                {
                  getFieldDecorator('robot_stauts', {
                    initialValue: my_summary_store.myInfo.robotStauts == 0 ? true : false,
                    valuePropName: 'checked',
                  })(
                    // <Checkbox
                    // />
                    <Checkbox>{'允许登录'}</Checkbox>
                  )
                }
              </FormItem>
              <FormItem
                style={this.formItemStyle}
                colon={false}>
                {
                  getFieldDecorator('recommended_status', {
                    initialValue: my_summary_store.myInfo.recommendedStatus == 0 ? true : false,
                    valuePropName: 'checked',
                  })(
                    <Checkbox>{'允许发展下级'}</Checkbox>
                  )
                }
              </FormItem>
              <FormItem
                style={this.formItemStyle}
                colon={false}>
                {
                  getFieldDecorator('is_withdrawal', {
                    initialValue: my_summary_store.myInfo.isWithdrawal == 0 ? true : false,
                    valuePropName: 'checked',
                    rules: []
                  })(
                    <Checkbox>{'允许提现'}</Checkbox>
                  )
                }
              </FormItem>
              {
                login_user_store.isFirstLevel ? (
                  <React.Fragment>
                    <FormItem
                      style={this.formItemStyle}
                      colon={false}>
                      {
                        getFieldDecorator('wallet_type', {
                          initialValue: my_summary_store.myInfo.walletType == 0 ? true : false,
                          valuePropName: 'checked',
                          rules: []
                        })(
                          <Checkbox>{'允许代充'}</Checkbox>
                        )
                      }
                    </FormItem>
                    <FormItem
                      style={this.formItemStyle}
                      colon={false}>
                      {
                        getFieldDecorator('is_change', {
                          initialValue: my_summary_store.myInfo.isChange == 0 ? true : false,
                          valuePropName: 'checked',
                          rules: []
                        })(
                          <Checkbox>{'允许会员转移'}</Checkbox>
                        )
                      }
                    </FormItem>
                    <FormItem
                      style={this.formItemStyle}
                      colon={false}>
                      {

                        getFieldDecorator('determinedstars', {
                          initialValue: my_summary_store.myInfo.determinedstars == 0 ? true : false,
                          valuePropName: 'checked',
                          rules: []
                        })(
                          <Checkbox>{'允许查看总输赢'}</Checkbox>
                        )
                      }
                    </FormItem>
                  </React.Fragment>
                ) : null
              }
              <FormItem style={this.formItemStyle}>
                <Button
                  type="primary"
                  onClick={this.handleSubmit}
                  loading={this.submitting}>
                  保存修改
                </Button>
              </FormItem>
            </Form>
          )
        } */}
      </div>
    )
  }
}

export default MySummary;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Pandect/MySummary/MySummary1.jsx